import React, { useMemo } from 'react';
import { Justify, Select } from 'tea-component';
import moment, { Moment } from 'moment';
import { getLocale } from 'umi';
import useLanguage from '@/pages/opinion/hooks/useLanguage';
import RangePicker from '@/pages/home/components/RangePicker';
import { getUtcTipsText } from '@/pages/opinion/utils/time';
import BubbleCommon from '@op/components/BubbleCommon';
import './GptFilter.scss';

export default function GptFilter({
  time,
  setTime,
  languageValue,
  setLanguageValue,
  options,
}: any) {
  const { formatMessage } = useLanguage();
  const lang = getLocale();

  const rangePickerValue = useMemo(() => {
    return time.map((time: string) => moment(time));
  }, [time]);

  // 获取时间的开始和结束时间 如果改变日期，这里value会返回[null, null]
  const onChangeRangePicker = (value: Array<Moment>) => {
    const hasTime = value.every(Boolean);
    let newValue: any = hasTime ? value : time;
    newValue = newValue.map((item: string) => {
      return (typeof item === 'string' ? moment(item) : item).format(
        'YYYY-MM-DD HH:mm:ss',
      );
    });
    if (!(newValue[0] === time[0] && newValue[1] === time[1])) {
      setTime(newValue);
    }
  };

  const langOptions = useMemo(() => {
    if (options) {
      return options;
    }
    return [
      { value: 'zh', text: formatMessage({ id: 'Simplified Chinese' }) },
      { value: 'en', text: formatMessage({ id: 'English' }) },
    ];
  }, [formatMessage, options]);

  return (
    <Justify
      className="dbo-gpt-report-select-wrapper"
      left={
        <div>
          <BubbleCommon
            placement="top"
            showIcon={false}
            tipsMap={getUtcTipsText({ fixedTimezone: 8 })}
          >
            <div
              className="date-select-wrapper search-item search-item-date"
              style={{ display: 'inline-block' }}
            >
              <RangePicker
                autoStartDay={false}
                onChange={onChangeRangePicker}
                value={rangePickerValue}
                type={'date'}
                showSelectType={false}
                typeList={['date']}
                language={lang === 'zh-CN' ? 'cn' : 'en'}
                startOfTime={'2001-01-01'}
              />
            </div>
          </BubbleCommon>
          <Select
            appearance="button"
            className="gpt-language-select"
            options={langOptions}
            value={languageValue}
            matchButtonWidth
            onChange={(value) => {
              setLanguageValue(value);
            }}
            button={(option) => (
              <div className="select-button">
                <div className="select-button-text">
                  {formatMessage({ id: 'Language' })}
                </div>
                <div className="dbo-select-flex">{option?.text}</div>
              </div>
            )}
          />
        </div>
      }
    />
  );
}
